import { useEffect, useRef } from "react";

const useScroll = (
  reference: any,
  time: number,
  enable = true,
  onEnd?: () => void
) => {
  const isUserInteracting = useRef(false);
  const blockTimeout = useRef<any>(null);

  useEffect(() => {
    const container = reference.current;
    if (!container) return;

    const onStart = () => {
      isUserInteracting.current = true;

      if (blockTimeout.current) {
        clearTimeout(blockTimeout.current);
      }

      blockTimeout.current = setTimeout(() => {
        isUserInteracting.current = false;
      }, 1500);
    };

    container.addEventListener("wheel", onStart);
    container.addEventListener("mousedown", onStart);
    container.addEventListener("touchstart", onStart);

    return () => {
      container.removeEventListener("wheel", onStart);
      container.removeEventListener("mousedown", onStart);
      container.removeEventListener("touchstart", onStart);
    };
  }, [reference]);

  useEffect(() => {
    const container = reference.current;
    if (!container || !enable) return;

    const seconds = time * 300;
    const incrementTime = seconds / container.scrollHeight;

    const interval = setInterval(() => {
      if (isUserInteracting.current) return;

      const reachedBottom =
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 2;

      if (reachedBottom) {
        container.scrollTop = 0;
        if (onEnd) onEnd();
      } else {
        container.scrollTop += 1;
      }
    }, incrementTime);

    return () => clearInterval(interval);
  }, [reference, time, enable, onEnd]);
};

export default useScroll;
